const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");

const fmtMoney = (value) => new Intl.NumberFormat("vi-VN").format(Math.round(Number(value) || 0));

export const getPrintTemplate = ({ headerInfo, rows, totals }) => {
  const rowsHtml = (rows || [])
    .map(
      (row, index) => `
      <tr>
        <td class="center">${index + 1}</td>
        <td>${escapeHtml(row.debitObject || "")}</td>
        <td class="right">${fmtMoney(row.account152Cost)}</td>
        <td class="right">${fmtMoney(row.account152Actual)}</td>
        <td class="right">${fmtMoney(row.account153Cost)}</td>
        <td class="right">${fmtMoney(row.account153Actual)}</td>
        <td class="right">${fmtMoney(row.account242)}</td>
      </tr>
    `
    )
    .join("");

  return `
  <html>
    <head>
      <meta charset="utf-8" />
      <title>Bảng Phân Bổ Nguyên Liệu, Vật Liệu, Công Cụ, Dụng Cụ</title>
      <style>
        @media print { @page { margin: 10mm 8mm 14mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 15px; color:#000; margin: 0; padding: 12px; }
        .header { display:flex; justify-content:space-between; align-items:flex-start; }
        .left { line-height:1.4; }
        .right { text-align:center; line-height:1.35; }
        .title { text-align:center; margin-top:12px; font-size:26px; font-weight:700; text-transform:uppercase; }
        .subtitle { text-align:center; margin-top:6px; font-style:italic; }
        .meta-right { text-align:right; margin-top:6px; }
        table { width:100%; border-collapse:collapse; margin-top:10px; font-size:14px; }
        th, td { border:1px solid #000; padding:4px; vertical-align:middle; }
        th { text-align:center; font-weight:700; }
        .center { text-align:center; }
        .right { text-align:right; }
        .signatures { margin-top:22px; display:flex; justify-content:space-between; text-align:center; }
        .sign-col { width:45%; }
        .sign-spacer { height: 16px; }
        .sign-date { font-style: italic; margin-bottom: 4px; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
        .diag-cell { position: relative; padding: 0; height: 64px; }
        .diag-line { position: absolute; inset: 0; background: linear-gradient(135deg, transparent 49.9%, #000 49.9%, #000 50.1%, transparent 50.1%); }
        .diag-top { position: absolute; top: 6px; right: 8px; font-weight: 700; font-size: 13px; }
        .diag-bottom { position: absolute; left: 8px; bottom: 6px; font-size: 12.5px; line-height: 1.2; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="left">
          <div><b>Đơn vị:</b> ${escapeHtml(headerInfo.unit || "")}</div>
          <div><b>Bộ phận:</b> ${escapeHtml(headerInfo.department || "")}</div>
        </div>
        <div class="right">
          <div><b>Mẫu số: 07 - VT</b></div>
          <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC</i></div>
          <div><i>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
        </div>
      </div>

      <div class="title">BẢNG PHÂN BỔ NGUYÊN LIỆU, VẬT LIỆU, CÔNG CỤ, DỤNG CỤ</div>
      <div class="subtitle">Tháng ${escapeHtml(headerInfo.month || "...")} năm ${escapeHtml(headerInfo.year || "....")}</div>
      <div class="meta-right">Số: ${escapeHtml(headerInfo.documentNumber || "")}</div>

      <table>
        <thead>
          <tr>
            <th rowspan="2" style="width:6%">STT</th>
            <th rowspan="2" style="width:30%">
              <div class="diag-cell">
                <div class="diag-line"></div>
                <div class="diag-top">Ghi Có các TK</div>
                <div class="diag-bottom">
                  <div>Đối tượng sử dụng</div>
                  <div>(Ghi Nợ các TK)</div>
                </div>
              </div>
            </th>
            <th colspan="2" style="width:18%">Tài khoản 152</th>
            <th colspan="2" style="width:18%">Tài khoản 153</th>
            <th rowspan="2" style="width:18%">Tài khoản 242</th>
          </tr>
          <tr>
            <th>Giá hạch toán</th>
            <th>Giá thực tế</th>
            <th>Giá hạch toán</th>
            <th>Giá thực tế</th>
          </tr>
          <tr>
            <th>A</th><th>B</th><th>1</th><th>2</th><th>3</th><th>4</th><th>5</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
          <tr>
            <td colspan="2" class="center"><b>Cộng</b></td>
            <td class="right"><b>${fmtMoney(totals.account152Cost)}</b></td>
            <td class="right"><b>${fmtMoney(totals.account152Actual)}</b></td>
            <td class="right"><b>${fmtMoney(totals.account153Cost)}</b></td>
            <td class="right"><b>${fmtMoney(totals.account153Actual)}</b></td>
            <td class="right"><b>${fmtMoney(totals.account242)}</b></td>
          </tr>
        </tbody>
      </table>

      <div class="signatures">
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Người lập bảng</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col">
          <div class="sign-date">Ngày... tháng... năm...</div>
          <div><b>Kế toán trưởng</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
      </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>
  `;
};
